// reducers/bookingDrawerReducer.js

export const initiaDrawerState = {
  loading: false,
  memberList: [],
  guestList: [],
  usersList: [],
  companyList: [],
  bookingUsers: [],
  mobileCodeList: [],
  greenFeeList: [],
  selectedCompany:null,
  subCategory:null,
  rateDetails: new Map(),
  // rateDetails: {GreenFee : 0, Bucket: 0, Club: 0, Discount: 0, Cgst : 0, Sgst : 0, Total : 0},
};

export function bookingDrawerReducer(state, action) {
  switch (action.type) {
    case 'SET_LOADING':
        return { ...state, loading: action.payload };

    case 'SET_COMPANY':
        return {...state, selectedCompany:action.payload};

    case 'SET_SUBCATEGORY':
        return {...state, subCategory: action.payload};   
        
    case 'SET_RATE_DETAILS':{      
      return {...state, rateDetails:(Object.keys(action.payload).length === 0) ? initiaDrawerState.rateDetails : action.payload};   
    }

    case 'SET_GREENFEE_LIST':
        return {...state, greenFeeList: action.payload};   
        
    case 'SET_GUEST_LIST':
        return {...state, guestList: action.payload};   

    case 'SET_BOOKING_DATA':
        return {
            ...state,
            memberList: action.payload.memberList,
            guestList: action.payload.guestList,
            usersList: action.payload.usersList,
            mobileCodeList: action.payload.mobileCodeList,
            companyList: action.payload.companyList,
            // bookingUsers: action.payload.bookingUsers ?? state.bookingUsers
        };

    case 'SET_BOOKING_USERS':
        return { ...state, bookingUsers: action.payload };
        // return state.bookingUsers.length === 0
        //     ? { ...state, bookingUsers: action.payload }
        //     : state;
    
    case 'SET_BOOKING_USERS_AND_RATE_DETAILS':{
      const { rateDetails: newRateDetails, bookingUsers } = action.payload;
      
      // clone existing map
      const updatedRateDetails = new Map(state.rateDetails);
      
      if (newRateDetails instanceof Map) {
        newRateDetails.forEach((value, key) => {
          updatedRateDetails.set(key, value);
        });
      } else if (typeof newRateDetails === 'object') {
        Object.entries(newRateDetails).forEach(([key, value]) => {
          updatedRateDetails.set(key, value);
        });
      }

      return {
        ...state,         
        rateDetails: updatedRateDetails,
        bookingUsers: bookingUsers
      }
    }      
    default:
        return state;
  }
}



// Action creators - these are the functions you can export and use in components
export const setLoading = (loading) => ({
  type: 'SET_LOADING', payload: loading
});

export const setCompany = (company) => ({
    type: 'SET_COMPANY', payload: company
});

export const setSubCategory = (sc) => ({
    type: 'SET_SUBCATEGORY', payload: sc
});

export const setRateDetails = (d) => ({
    type: 'SET_RATE_DETAILS', payload: d
});

export const setBookingData = (bookingData) => ({
  type: 'SET_BOOKING_DATA', payload: bookingData
});

export const setBookingUsers = (users, calledFrom) =>{
  // console.log('calledFrom', calledFrom);
  return({
    type: 'SET_BOOKING_USERS', payload: users
  });
} 

export const setGreenFeeList = (gf) => ({
  type: 'SET_GREENFEE_LIST', payload: gf
});

export const setGuestList = (gl) => ({
  type: 'SET_GUEST_LIST', payload: gl
});

export const setBookingUsersAndRateDetails = (data) => { 
  return ({
    type: 'SET_BOOKING_USERS_AND_RATE_DETAILS', payload: data
})};
